import useSupabaseSession from 'hooks/useSupabaseSession';
import { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const useUserData = () => {
    const { accessToken } = useSupabaseSession();
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchUserData = async () => {
            console.log('Fetching user data...');
            if (!accessToken) {
                // console.error('No access token found');
                return
            } 

            // console.log(`Access token: ${accessToken}`);

            try {
                const response = await fetch(`${API_BASE_URL}/fetch_user_data`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                console.log(`Access token: ${accessToken}`);
                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`Failed to fetch user data (${response.status}): ${errorText}`);
                }
                const data = await response.json();
                setUserData(data);
                console.log('User data:', data);
            } catch (err) {
                console.error('Error fetching user data:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        }
        fetchUserData();
    }, [accessToken]);

    return { userData, loading, error };

};

export default useUserData;